var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "staff-icon-small.d4042bdb.png","uri@2x": __webpack_public_path__ + "staff-icon-small.0d25b0e6.png","uri@3x": __webpack_public_path__ + "staff-icon-small.7902e473.png",
    width: 13,
    height: 14
});